import es_ES from 'ant-design-vue/es/locale/es_ES';

const messages = {
  summary: {
    title: 'Tu pedido se encuentra:',
    promoted: 'Actualizado {date}.',
    finished: 'Finalizado {date}.',
  },
  events: {
    title: 'Seguimiento de tu envío',
  },
  status: {
    CREATED: {
      title: 'En preparación',
      subtitle: 'Tu pedido está siendo preparado por el vendedor.',
    },
    PREPARED: {
      title: 'Listo para enviar',
      subtitle: 'Tu pedido fue preparado y está listo para enviarse.',
    },
    IN_TRANSIT:  {
      title: 'En manos del mensajero',
      subtitle: 'Tu pedido ha sido enviado por el vendedor.',
    },
    ON_THE_WAY: {
      title: '¡Visita en camino!',
      subtitle: 'Tu pedido está en camino hacia tu domicilio.',
    },
    FAILED: {
      title: 'No se pudo entregar',
      subtitle: 'Tu pedido aún no ha podido entregarse.',
    },
    DELIVERED: {
      title: '¡Entregado!',
      subtitle: 'Tu pedido ya fue entregado en tu domicilio.',
    },
    RETURNED: {
      title: '¡Retornado!',
      subtitle: 'Tu pedido ha sido retornado al vendedor.',
    },
    CANCELED: {
      title: 'Cancelado',
      subtitle: 'Tu pedido ha sido cancelado.',
    },
  }
}

export default {
  locale: 'es-ES',
  antd: es_ES,
  messages,
}
